const initialState = {
  addedGroupMembers: [],
  removedGroupMembers: [],
};

export default initialState;
